import React from 'react';

/* ============================================================
   OutcomesBar — bloc de filtres outcomes (token_outcomes ⋈ bc_pda).
   Boutons preset : PEAK · MIGRÉ · RUG · T-PEAK · SURVIE · TIME-TO-RUG.
   Partagé entre TokensPage et PositionsPage.
   Opère sur un objet `filters` :
     { min_peak, oc_migrated, oc_rugged, tp_min, tp_max, oc_life_min, oc_life_max }
   et appelle onChange(patch).
   ============================================================ */

// ---- Presets filtres outcomes, style popup drill-down ----
export const OC_PEAK = [
  { label: 'Tous', v: '' }, { label: '≥+50%', v: 50 }, { label: '≥+100%', v: 100 },
  { label: '≥+300%', v: 300 }, { label: '≥+500%', v: 500 }, { label: '≥+1000%', v: 1000 },
];
export const OC_TP = [
  { label: 'Tous', tp_min: '', tp_max: '' }, { label: '≤2s', tp_min: '', tp_max: 2 },
  { label: '≤10s', tp_min: '', tp_max: 10 }, { label: '≥30s', tp_min: 30, tp_max: '' },
];
export const OC_LIFE = [
  { label: 'Toutes', v: '' }, { label: '≥1min', v: 60 }, { label: '≥10min', v: 600 }, { label: '≥1h', v: 3600 },
];
// time-to-rug = lifetime d'un token rugé → force oc_rugged='true' + borne lifetime
export const OC_TTR = [
  { label: 'Tous', oc_rugged: '', oc_life_min: '', oc_life_max: '' },
  { label: '≤30s', oc_rugged: 'true', oc_life_min: '', oc_life_max: 30 },
  { label: '≤2min', oc_rugged: 'true', oc_life_min: '', oc_life_max: 120 },
  { label: '≤10min', oc_rugged: 'true', oc_life_min: '', oc_life_max: 600 },
  { label: '≥1h (lent)', oc_rugged: 'true', oc_life_min: 3600, oc_life_max: '' },
];
export const _s = (v) => String(v ?? '');

function OutcomesBar({ filters, onChange }) {
  const btn = (active) => ({
    background: active ? '#191c23' : 'none',
    border: `1px solid ${active ? '#22d3ee' : 'var(--border)'}`,
    color: active ? '#22d3ee' : 'var(--text2)',
    fontFamily: 'inherit', fontSize: 10, fontWeight: 600, padding: '5px 11px',
    borderRadius: 6, cursor: 'pointer', letterSpacing: '.04em',
  });
  const lbl = { fontSize: 9.5, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--text2)', fontWeight: 600, marginRight: 2 };
  const row = { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 8 };
  const ttrActive = (o) => o.label !== 'Tous'
    && filters.oc_rugged === 'true' && _s(filters.oc_life_max) === _s(o.oc_life_max) && _s(filters.oc_life_min) === _s(o.oc_life_min);
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '10px 12px', marginBottom: 12 }}>
      <div style={row}>
        <span style={lbl}>Peak</span>
        {OC_PEAK.map((o) => <button key={o.label} style={btn(_s(filters.min_peak) === _s(o.v))} onClick={() => onChange({ min_peak: o.v })}>{o.label}</button>)}
        <span style={{ ...lbl, marginLeft: 8 }}>Migré</span>
        {[['Tous', ''], ['Oui', 'true'], ['Non', 'false']].map(([l, v]) => <button key={l} style={btn(filters.oc_migrated === v)} onClick={() => onChange({ oc_migrated: v })}>{l}</button>)}
      </div>
      <div style={row}>
        <span style={lbl}>Rug</span>
        {[['Tous', ''], ['Sans rug', 'false'], ['Que rug', 'true']].map(([l, v]) => <button key={l} style={btn(filters.oc_rugged === v)} onClick={() => onChange({ oc_rugged: v })}>{l}</button>)}
        <span style={{ ...lbl, marginLeft: 8 }}>t-peak</span>
        {OC_TP.map((o) => <button key={o.label} style={btn(_s(filters.tp_min) === _s(o.tp_min) && _s(filters.tp_max) === _s(o.tp_max))} onClick={() => onChange({ tp_min: o.tp_min, tp_max: o.tp_max })}>{o.label}</button>)}
      </div>
      <div style={row}>
        <span style={lbl}>Survie</span>
        {OC_LIFE.map((o) => <button key={o.label} style={btn(_s(filters.oc_life_min) === _s(o.v) && _s(filters.oc_life_max) === '')} onClick={() => onChange({ oc_life_min: o.v, oc_life_max: '' })}>{o.label}</button>)}
      </div>
      <div style={{ ...row, marginBottom: 0 }}>
        <span style={lbl}>Time-to-rug</span>
        {OC_TTR.map((o) => <button key={o.label} style={btn(ttrActive(o))} onClick={() => onChange({ oc_rugged: o.oc_rugged, oc_life_min: o.oc_life_min, oc_life_max: o.oc_life_max })}>{o.label}</button>)}
      </div>
    </div>
  );
}

export default OutcomesBar;
